import { AccountSettingKeyEnum } from '@portal/models/enumerators';

export const selectPortabilityEnabled = (config?: models.Config[]): boolean =>
  config?.find((c) => c.key === AccountSettingKeyEnum.PORTABILITY_ENABLE)
    ?.value === 'true';

export const selectRechargeEnabled = (config?: models.Config[]): boolean =>
  config?.find((c) => c.key === AccountSettingKeyEnum.RECHARGE_ENABLE)
    ?.value === 'true';
